import { createContext, useContext } from 'react';
import type { EoeClaimTabId } from './eoeClaimsManagerTabs';

export const EOEClaimsManagerTabContext = createContext<EoeClaimTabId | null>(
  null
);

export function useEOEClaimsManagerTab(): EoeClaimTabId | null {
  return useContext(EOEClaimsManagerTabContext);
}
